export default {"src":"/_next/static/media/list_64.a0409b96.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};